<template>
  <div class="container company text-center">
    <h3>ບໍລິສັດ/ ຂໍ້ມູນ ຫຼັກຊັບ</h3>
    <div class="list">
      <img src="@/assets/theme/a.png">
      <img src="@/assets/theme/b.png">
      <img src="@/assets/theme/c.png">
      <img src="@/assets/theme/d.png">
      <img src="@/assets/theme/e.png">
      <img src="@/assets/theme/f.png">
      <img src="@/assets/theme/g.png">
      <img src="@/assets/theme/h.png">
      <img src="@/assets/theme/i.png">
      <img src="@/assets/theme/j.png">
      <img src="@/assets/theme/k.png">
    </div>
  </div>
</template>
<script>
export default {
  name: 'ListCompany'
}
</script>
<style lang="scss" scoped>
.company {
  border-top: 2px solid #CCDCEA;
  padding-top: 15px;

  .list {
    img {
      margin: 2px;
    }
  }
}
</style>
